import React, {useEffect, useState} from "react";
import { useNavigate} from "react-router-dom";
import InitConfirm from "../../components/estateOriginality/InitConfirm";
import Api from "../../tools/service";
import Swal from "sweetalert2";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import Button from "../../components/Button";
import {TbShieldCheckFilled} from "react-icons/tb";
import {MdClose} from "react-icons/md";
import Payment from "../../components/estateOriginality/Payment";
import BugModal from "../../components/BugModal";
import {BiSupport} from "react-icons/bi";
import ProgressBar from "../../components/ProgressBar";
import {calculateOtpTimer, divarLinkGenerator, persianToEnglish, safeRedirect} from "../../tools/helpers";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../components/modals/ErrorModal";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import requestOTP from "../../tools/api/estate/requestOTP";
import confirmOTP from "../../tools/api/estate/confirmOTP";
import skipShahkar from "../../tools/api/estate/skipShahkar";
import OTP from "../../components/estateOriginality/OTP";
import useDivarAuth from "../../hooks/useDivarAuth";

const otpConfig = {
    title: 'کد اعتبار سنجی',
    length: 5,
}
const EstateOriginality = () => {
    const {token,postToken,returnUrl,platformUser}=useDivarAuth();
    const [processInfo, setProcessInfo] = useState(null);
    const [pid, setPid] = useState(null)
    const mobile = platformUser ? platformUser.phone_number : null;
    const [isLoading, setLoading] = useState(true)
    const [widget, setWidget] = useState(null);
    const [bugReportData, setBugReportData] = useState(null)
    const [showReport, setShowReport] = useState(false)
    const [openReportModal, setOpenReportModal] = useState(false)
    const [showSupportActions, setShowSupportActions] = useState(false);
    const [otpConfirmLoading, setOtpConfirmLoading] = useState(false);
    const [otpRequestLoading, setRequestOtpLoading] = useState(false);
    const [otpError, setOtpError] = useState(null)
    const [otpDescription, setOtpDescription] = useState(null)
    const navigate = useNavigate();
    const [hasWidget, setHasWidget] = useState(false);
    const [otpActive, setOtpActive] = useState(false);
    const [otpTimer, setOtpTimer] = useState(null);
    const [warning, setWarning] = useState(null);
    const [isReported, setReported] = useState(false)
    const handleResetProcess = (canReset, message) => {
        Swal.fire({
            allowOutsideClick: false,
            text: message,
            title: "ناموفق",
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#d51e3e',
            confirmButtonText: canReset ? 'شروع مجدد' : 'ساخت پروسه جدید',

        }).then((result) => {
            if (result.isConfirmed) {
                if (canReset) {
                    setLoading(true)
                    Api.put(REQUEST_URLS.ESTATE.RESET, {
                        pid: pid,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    }).then((response) => {
                        if (!response.hasError) {

                            handleGetProcess()

                        } else {
                            setLoading(false)
                            Swal.fire({
                                allowOutsideClick: false,
                                text: response.message,
                                title: "ناموفق",
                                icon: 'error',
                                showCancelButton: false,
                                confirmButtonColor: '#d51e3e',
                                showConfirmButton: true,
                                confirmButtonText: 'تلاش مجدد',
                            }).then(() => {

                            })
                        }

                    }).catch((e) => {

                        Swal.fire({
                            allowOutsideClick: false,
                            text: e.response.message,
                            title: "ناموفق",
                            icon: 'error',
                            showCancelButton: true,
                            cancelButtonColor: '#d51e3e',
                            showConfirmButton: false,
                            cancelButtonText: 'تلاش مجدد',
                        })
                    }).finally(() => {

                    })
                } else {
                    //create new process;

                    handleCreateProcess();
                }
            }
        })
    }
    const handleRedirect = (status, price) => {
        const link = divarLinkGenerator({
            returnUrl,
            price: price,
            status: status,
        });
        safeRedirect(link, () => {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: 'لینک معتبر نمی باشد.',
                showCancelButton: true,
                cancelButtonText: 'بستن',
                onCancel: () => {
                    Reoverlay.hideModal();
                    navigate('/404')
                }
            })
        })
    }
    const handleInquiryProcess = () => {
        Api.get(REQUEST_URLS.ESTATE.INQUIRY_PROCESS, {
            params: {
                post_token:postToken
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((response) => {
            const {data, hasError, status, message} = response;
            if (!hasError) {
                if (!!data?.process && !!data?.process?.pid) {
                    if (data?.process?.current_step?.name !== "final") {
                        setPid(data?.process?.pid)
                    }
                    if (data?.widget?.has_widget) {
                        setHasWidget(true)
                        setLoading(false);
                        setWidget({
                            im_owner: data?.widget?.im_owner,
                            i_have_access_to_owner: data?.widget?.i_have_access_to_owner,
                            ...data?.widget?.widgets_body
                        })
                    } else {
                        if (data?.process?.current_step?.name !== "final") {
                            handleGetProcess(data?.process?.pid);
                        } else {
                            handleCreateProcess();
                        }

                    }
                } else {
                    handleCreateProcess();

                }

            } else {
                handleError({
                    message,
                    status,
                    data,
                    callback:()=>{
                        Swal.fire({
                            text: message,
                            title: "ناموفق",
                            icon: 'error',
                            backdrop: true,
                            focusConfirm: false,
                            showCancelButton: true,
                            cancelButtonColor: '#d51e3e',
                            cancelButtonText: 'تلاش مجدد',
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {

                            } else {
                                handleInquiryProcess();
                            }
                        })
                    }
                })
            }

        }).catch(e => {
                console.log(e)
        }).finally(() => {
        })
    }
    const handleCreateProcess = () => {
        //1
        setLoading(true);
        const data = {
            "platform_user_id": mobile,
            "post_token":postToken,
        };


        Api.post(REQUEST_URLS.ESTATE.CREATE_PROCESS, data, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((response) => {
            const {data, message, status, hasError} = response;
            if (!hasError) {
                if (data) {
                    setPid(data.pid);
                    handleGetProcess(data.pid);
                }
            } else {
                handleError({
                    message, status, data, callback: () => {
                        Swal.fire({
                            text: message,
                            title: "ناموفق",
                            icon: 'error',
                            backdrop: true,
                            focusConfirm: false,
                            showCancelButton: true,
                            cancelButtonColor: '#d51e3e',
                            confirmButtonColor: '#0a8c52',
                            confirmButtonText: 'تلاش مجدد',
                            cancelButtonText: 'بازگشت',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                handleCreateProcess();
                            } else {
                                handleRedirect()
                            }
                        })
                    }
                })
            }
        }).catch(() => {

        })
    }
    const handleGetProcess = (currentPid) => {
        setLoading(true);
        setOtpActive(false);
        Api.get(REQUEST_URLS.ESTATE.FETCH_PROCESS, {
            params: {
                pid: (currentPid ? currentPid : pid)
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((response) => {
            const {data, hasError, status, message} = response;
            if (!hasError) {
                setLoading(false)

                setProcessInfo(data.process)
                if (data?.process.current_step.name === 'final') {
                    setPid(null)
                }
            } else {
                setLoading(false)
                handleError({
                    message, status, data, callback: () => {
                        Swal.fire({
                            text: message,
                            title: "ناموفق",
                            icon: 'error',
                            backdrop: true,
                            focusConfirm: false,
                            showCancelButton: true,
                            cancelButtonColor: '#d51e3e',
                            confirmButtonColor: '#0a8c52',
                            confirmButtonText: 'تلاش مجدد',
                            cancelButtonText: 'بازگشت',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                handleGetProcess();
                            } else {
                                handleRedirect()
                            }
                        })
                    }
                })
            }
        }).catch((e) => {


        }).finally(() => {
            setLoading(false)
        })

    }
    const handleShahkar = () => {
        setLoading(true)
        handleGenerateUuid('Shahkar', token).then(uuid => {
            setLoading(true)
            Api.post(REQUEST_URLS.ESTATE.SHAHKAR, {
                pid: pid,
                uuid: uuid,
            }).then((response) => {
                const {data, hasError, status, message} = response;
                if (!hasError) {
                    updateStep(data.next_step)
                } else {

                    handleError({
                        message,
                        status,
                        data,
                        hasSkip: data?.can_skip,
                        onSkip: async () => {
                            await handleSkipShahkar(pid)
                        },
                        callback: () => {

                            Swal.fire({
                                text: message,
                                title: "ناموفق",
                                icon: 'error',
                                showCancelButton: status === 360 && data?.can_skip,
                                cancelButtonText: "رد شدن",
                                cancelButtonColor: "#419e53",
                                confirmButtonColor: '#d33',
                                confirmButtonText: data?.can_reset ? "ویرایش اطلاعات" : "تلاش مجدد",
                                showConfirmButton: true,
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    if (status === 360) {
                                        handleResetProcess(data?.can_reset, message)
                                    } else {
                                        handleShahkar()
                                    }
                                } else {
                                    if (data?.can_skip)
                                        await handleSkipShahkar(pid)
                                }
                            });
                        }
                    })


                }

            }).catch(() => {

            }).finally(() => {
                setLoading(false)
            })

        })
            .catch(error => {
                console.error(error);
                setLoading(false)
            });

    }
    const handleEstateInquiry = () => {
        setLoading(true);
        handleGenerateUuid('EstateInquiry', token).then(uuid => {
            Api.post(REQUEST_URLS.ESTATE.ESTATE_INQUIRY, {
                uuid: uuid,
                pid: pid,
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(response => {

                if (!response.hasError) {
                    setWarning(response.data.warning)
                    updateStep(response.data.next_step)

                } else {
                    handleError({
                        message: response.message, data: response.data, status: response.status, callback: () => {
                            Swal.fire({
                                text: response.message,
                                title: "ناموفق",
                                icon: 'error',
                                showCancelButton: false,
                                confirmButtonColor: '#d33',
                                confirmButtonText: "تلاش مجدد",
                                showConfirmButton: true,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    handleEstateInquiry()
                                }
                            });
                        }
                    })
                }
            }).finally(() => {
                setLoading(false)
            })
        })

    }
    useEffect(() => {
        if (processInfo && processInfo.current_step.name === 'Shahkar') {
            handleShahkar()
            //when user Step is Shahkar automatic call Shahkar function
        } else if (processInfo && processInfo.current_step.name === 'EstateInquiry') {
            handleEstateInquiry()
        } else if (processInfo && (processInfo.current_step.name === 'CreatePayment' || processInfo.current_step.name === 'InquiryPayment')) {
            setLoading(false)
        }
    }, [processInfo])
    const handleError = ({
                             message, hasSkip = false, onSkip = () => {
        }, status, data, callback = () => {
        }
                         }) => {
        if (status === -9) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'بازگشت به دیوار',
                confirmButtonTheme: "red",
                onConfirm: () => {
                    handleRedirect('fail', processInfo?.payment?.info?.init_amount);
                }
            })
        }else if(status===-10){
            setReported(true);
            setWarning(message);
            setLoading(false)
        } else if (status === -20) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: false,
                showConfirmButton: false,
            })
        } else if (status == '403'||status=='401') {
            Swal.fire({
                text: message,
                title: "ناموفق",
                icon: 'error',
                backdrop: true,
                focusConfirm: false,
                showCancelButton: true,
                cancelButtonColor: '#d51e3e',
                cancelButtonText: 'بازگشت',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {

                } else {
                    handleRedirect()
                }
            })
        } else if (status == '801' || status == '802' || status === -100 || status == '803' || status == '805') {
            Swal.fire({
                text: message,
                title: "ناموفق",
                icon: 'error',
                backdrop: true,
                focusConfirm: false,
                showCancelButton: false,
                confirmButtonColor: '#d51e3e',
                confirmButtonText: 'شروع مجدد',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {

                    handleCreateProcess()
                } else {

                }
            })


        } else if (data && data?.can_reset) {
            if (processInfo?.current_step) {

                Swal.fire({
                    allowOutsideClick: false,
                    text: message,
                    title: "ناموفق",
                    icon: 'error',
                    showCancelButton: true,
                    cancelButtonColor: '#d51e3e',
                    confirmButtonColor: '#419e53',
                    confirmButtonText: 'رد کردن',
                    showConfirmButton: hasSkip,
                    cancelButtonText: data && data?.can_reset ? 'ویرایش اطلاعات' : 'شروع مجدد',

                }).then((result) => {
                    if (!result.isConfirmed) {
                        if (data.can_reset) {
                            setLoading(true)
                            Api.put(REQUEST_URLS.ESTATE.RESET, {
                                pid: pid,
                            }, {
                                headers: {
                                    "Authorization": `Bearer ${token}`
                                }
                            }).then((response) => {
                                if (!response.hasError) {
                                    handleGetProcess()

                                } else {
                                    setLoading(false)
                                    Swal.fire({
                                        allowOutsideClick: false,
                                        text: response.message,
                                        title: "ناموفق",
                                        icon: 'error',
                                        showCancelButton: false,
                                        confirmButtonColor: '#d51e3e',
                                        showConfirmButton: true,
                                        confirmButtonText: 'تلاش مجدد',
                                    }).then(() => {

                                    })
                                }

                            }).catch((e) => {

                                Swal.fire({
                                    allowOutsideClick: false,
                                    text: e.response.message,
                                    title: "ناموفق",
                                    icon: 'error',
                                    showCancelButton: true,
                                    cancelButtonColor: '#d51e3e',
                                    showConfirmButton: false,
                                    cancelButtonText: 'تلاش مجدد',
                                })
                                setLoading(false)
                            }).finally(() => {

                            })
                        } else {

                            handleCreateProcess();
                        }
                    } else {
                        if (hasSkip)
                            onSkip();
                    }
                })

            }
        } else {

            callback()
        }
    }

    useEffect(() => {
        Api.get('/api/v1/options').then((response) => {
            if (!response.hasError) {
                if (response.data) {
                    response.data.forEach((item, index) => {
                        if (item.key === "report_settings") {
                            setShowReport(true);
                            const data = JSON.parse(item.value);


                            setBugReportData(JSON.parse(item.value));

                        }
                    })
                }
            }
        }).catch(e => {

        }).finally(() => {

        })
        if (!pid) {

            handleInquiryProcess();
        } else if (pid) {
            handleGetProcess();
        }

    }, []);
    const updateStep = (newStep) => {
        setProcessInfo({
            ...processInfo,
            current_step: newStep
        })
    }
    const handleCreatePayment = (discount, redirect = true) => {
        if (processInfo?.payment?.payment_required && !processInfo?.payment?.paid) {

            setLoading(true)
            const data = {
                "pid": pid,
                discount_code: discount,
            }
            Api.post(REQUEST_URLS.ESTATE.CREATE_PAYMENT, data, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(response => {

                const {hasError, status, message, data} = response;

                if (!hasError) {
                    if (redirect) {
                        safeRedirect(data.data.pay_url, () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: 'لینک معتبر نمی باشد.',
                                showCancelButton: true,
                                cancelButtonText: 'بستن',
                                onCancel: () => {
                                    Reoverlay.hideModal();
                                    setLoading(false);
                                    navigate('/404')

                                }
                            });
                        })

                    } else {
                        setProcessInfo({
                            ...processInfo,
                            payment: {
                                ...processInfo.payment,
                                ...data.data,
                                info: data?.payment_info
                            }
                        })
                        setLoading(false)
                    }


                } else {
                    setLoading(false)
                    handleError({
                        message, status, data, callback: () => {
                            Swal.fire({
                                allowOutsideClick: false,
                                text: message,
                                title: "ناموفق",
                                icon: 'error',
                                showCancelButton: false,
                                confirmButtonColor: '#d51e3e',
                                showConfirmButton: true,
                                confirmButtonText: 'تلاش مجدد',
                            });
                            setLoading(false)
                        }
                    })
                }

            }).catch(e => {
                console.log(e)
                setLoading(false)
            })
        }


    }
    const handleSkipShahkar = async (pid) => {
        setLoading(true)
        const response = await skipShahkar(token, {pid});
        setLoading(false);
        const {hasError, status, message, data} = response;
        if (hasError) {
            handleError({
                message, status, data, callback: () => {

                    Swal.fire({
                        allowOutsideClick: false,
                        text: message,
                        title: "ناموفق",
                        icon: 'error',
                        showCancelButton: true,
                        cancelButtonColor: '#d51e3e',
                        showConfirmButton: false,
                        cancelButtonText: 'تلاش مجدد',

                    }).then(async (result) => {
                        if (!result.isConfirmed) {

                        } else {
                            await handleSkipShahkar(pid)
                        }
                    })
                    setLoading(false)
                }
            })
        } else {
            handleGetProcess(pid)
        }
    }
    const handleInitConfirm = (values) => {

        setLoading(true);
        handleGenerateUuid('EstateInquiry', token).then(uuid => {

            const data = {
                "uuid": uuid,
                "pid": pid,
                "Mobile": values.im_owner ? processInfo?.platform_user : persianToEnglish(values.mobile),
                "im_owner": values.im_owner,
                "i_have_access_to_owner": values.i_have_access_to_owner,
                "Basic": persianToEnglish(values.basic),
                "Secondary": persianToEnglish(values.secondary),
                "NationalId": persianToEnglish(values.nid),
                "UnitId": values.unitId,
                "DocumentType": values.documentType,
                "UniqueId": persianToEnglish(values.uniqueId),
                "OfficeNumber": persianToEnglish(values.officeNumber),
                "PageNumber": persianToEnglish(values.pageNumber)
            };

            Api.put(REQUEST_URLS.ESTATE.INIT_CONFIRM, data, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(async response => {
                if (!response.hasError) {
                    if (response.data.otp_required) {

                        await handleRequestOTP();


                    } else {
                        setLoading(true)
                        handleGetProcess(processInfo.pid)
                    }

                } else {
                    handleError({
                        message: response.message, status: response.status, callback: () => {
                            Swal.fire({
                                text: response.message,
                                title: "ناموفق",
                                icon: 'error',
                                backdrop: true,
                                focusConfirm: false,
                                showCancelButton: false,
                                confirmButtonColor: '#d51e3e',
                                confirmButtonText: 'شروع مجدد',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    handleCreateProcess()
                                }
                            })
                        }
                    })
                }
            })
        })


    }
    const showDeleteWidgetConfirm = () => {
        Swal.fire({
            customClass: {
                cancelButton: 'btn-outline-red',
                title: 'text-red-400 mt-4 mb-5 '
            },
            allowOutsideClick: false,
            icon: ``,
            text: 'با عملیات حذف، افزونه از روی آگهی شما حذف شده و با پرداخت مجدد می‌توانید تاییدیه اصالت ملک را دریافت کنید.',
            title: "حذف افزونه ملک",

            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'حذف',
            confirmButtonColor: '#d51e3e',
            cancelButtonText: 'لغو',

        }).then(result => {
            if (result.isConfirmed) {
                handleDeleteWidget()
            }
        })
    }
    const handleDeleteWidget = () => {
        setLoading(true)
        Api.delete(REQUEST_URLS.ESTATE.DELETE_WIDGET, {
            params: {
                post_token:postToken
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((response) => {
            const {hasError, message} = response;
            if (!hasError) {
                Swal.fire({
                    allowOutsideClick: false,
                    text: message,
                    title: "موفق",
                    icon: 'success',
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'بستن',
                    confirmButtonColor: '#419e53'
                }).then(result => {
                    if (result.isConfirmed) {
                        setWidget(null)
                    }
                })
            } else {
                Swal.fire({
                    allowOutsideClick: false,
                    text: message,
                    title: "خطا",
                    icon: 'error',
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonColor: '#fd4747',
                    confirmButtonText: 'تلاش مجدد'
                }).then((result => {
                    if (result.isConfirmed) {
                        handleDeleteWidget()
                    }
                }))
            }
            setLoading(false)
        }).catch((e) => {
            console.log(e)
            setLoading(false)
        })
    }
    const handleStart = () => {
        setLoading(true)
        if (pid) {
            setWidget(null);
            setHasWidget(false)
            handleGetProcess();

        } else {
            setWidget(null);
            setHasWidget(false)
            handleCreateProcess()
        }
    }
    const handleShowReport = () => {
        setOpenReportModal(true)
    }
    const handleToggleAction = () => {
        setShowSupportActions(!showSupportActions)
    }
    const handleRequestOTP = async () => {
        setRequestOtpLoading(true);
        setOtpError(null)
        const response = await requestOTP(token, {pid: processInfo.pid});
        setLoading(false);
        setRequestOtpLoading(false)
        if (response.hasError) {
            setOtpError(response.message);
        } else {
            const time = calculateOtpTimer(response.data.created_at, 120);
            setOtpTimer(time);
            setOtpActive(true)
            setOtpDescription(response.message)
        }
    }
    const handleConfirmOTP = async (value) => {
        setOtpConfirmLoading(true);
        setOtpError(null);
        const response = await confirmOTP(token, {pid: processInfo.pid, code: persianToEnglish(value)});
        setOtpConfirmLoading(false)
        if (response.hasError) {
            setOtpError(response.message);

        } else {

            handleGetProcess(processInfo.pid)
        }
    }
    if (isLoading) {
        return <ProgressBar theme="green" duration={30} type="Estate"/>
    }
    if (hasWidget) {
        return <div className="mt-5 flex flex-col justify-center items-center mx-auto w-11/12 md:w-6/12 lg:w-4/12">

            {widget && <>
                <h1 className="text-lg font-bold mb-2 mb-1 text-center ">تایید اصالت ملک </h1>
                <p className="text-center      text-sm">افزونه اصالت ملک شما به صورت زیر روی آگهی قرار دارد.</p>
                <div className="p-3 mt-3  w-full mx-auto flex flex-col   rounded-lg bg-white">

                    <div className="border rounded-lg p-3 ">
                        <div className="w-full flex justify-start items-center">
                            <img
                                src="data:image/jpeg;base64,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"
                                className="h-auto w-16 " alt=""/>
                            <div className="flex pr-4  flex-col">
                                <strong className="text-lg">ونیفای</strong>
                                <span className="text-sm">{widget?.Shahkar?.title}</span>
                            </div>
                        </div>
                        <div className="w-full border-t border-b  pb-3  pt-3 mt-3  grid grid-cols-2">
                            <div className="flex justify-center border-l items-center flex-col">
                <span className="text-sm">
                مساحت
                </span>
                                <span className="font-bold text-sm">
            {widget?.Area || '-'}
                </span>
                            </div>
                            <div className="flex justify-center items-center flex-col">
                <span className="text-sm">
                نوع ملک
                </span>
                                <span className="text-sm font-bold">
            {widget?.PieceType || '-'}
                </span>
                            </div>

                        </div>
                        <div className="w-full  border-b   pt-3 pb-3  mt-3  grid grid-cols-2">
                            <div className="flex justify-center border-l items-center flex-col">
                <span className="text-sm">
                وضعیت خاص
                </span>
                                <span className="font-bold text-sm">
            {widget?.StateType || '-'}
                </span>
                            </div>
                            <div className="flex justify-center items-center flex-col">
                <span className="text-sm">
                کاربری
                </span>
                                <span className="text-sm font-bold">
            {widget?.UsingType || '-'}
                </span>
                            </div>

                        </div>
                        <div className="flex justify-center">
                            <p className="mt-3  text-center  ">محدودیت‌ها</p>
                        </div>
                        <div className="w-full   pb-3   pt-3   grid grid-cols-3">
                            <div className="flex border-l pl-2 justify-start items-center flex-col">
                                 <span className="text-sm">
                رهنی
                </span>
                                <span className="font-bold  text-center text-sm">
            {widget?.HasRahn || '-'}
                </span>
                            </div>
                            <div className="flex border-l pl-2 justify-start items-center flex-col">
                            <span className="text-sm">
                بازداشتی
                </span>
                                <span className="text-sm font-bold">
            {widget?.IsArrested || '-'}
                </span>
                            </div>
                            <div className="flex justify-start items-center flex-col">
                             <span className="text-sm">
                سایر محدودیت‌ها
                </span>
                                <span className="text-sm font-bold">
            {widget?.OtherRestrict || '-'}
                </span>
                            </div>

                        </div>
                        <div className="w-full">
                            <div className="w-full justify-between flex p-2 border-t items-center">
                                <span className="text-sm">آگهی گذار صاحب ملک؟ </span>
                                <span>{widget?.im_owner ? <span className="text-sm text-green-500">بله</span> :
                                    <span className="text-sm text-red-400">خیر</span>}</span>
                            </div>
                        </div>
                        <div className="w-full">
                            <div className="w-full justify-between flex p-2 border-t items-center">
                                <span className="text-sm">آگهی مورد تایید صاحب ملک ؟ </span>
                                <span>{widget?.i_have_access_to_owner ?
                                    <span className="text-sm text-green-500">بله</span> :
                                    <span className="text-sm text-red-400">خیر</span>}</span>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-2 mt-5   ">
                        <Button className="text-sm" onClick={showDeleteWidgetConfirm} rounded="rounded-lg" theme="red">حذف
                            افزونه</Button>

                    </div>
                </div>
            </>}
            <div
                className="bg-white p-5 mb-4 mt-5 flex flex-col items-center justify-center  rounded-lg   w-full ">
                {!widget && <h1 className="text-lg font-bold mb-2  text-center ">تایید اصالت ملک </h1>}
                <p className="text-center text-sm ">با پرداخت مجدد می‌توانید فرایند جدید را آغاز کنید.</p>
                <Button onClick={handleStart} className="text-sm mt-2 w-full " rounded="rounded-lg"
                        theme="green">{pid ? 'ادامه' : 'شروع فرایند جدید'} </Button>
            </div>
        </div>
    }
    return <div>
        {openReportModal && <BugModal
            accessToken={token}
            type="Estate"
            requestUrl={REQUEST_URLS.ESTATE.REPORT}
            onClose={() => {
                setOpenReportModal(false);
                setShowSupportActions(false)
            }}
            data={bugReportData}/>}
        {!isLoading && <div>
            {showSupportActions && showReport && <button onClick={handleShowReport}
                                                         className="fixed bg-white bg-opacity-80  shadow-2xl text-red-400   bottom-40 p-3  text-sm flex justify-center items-center rounded-full left-5 z-30">گزارش
                خطا</button>}
            {showSupportActions && <a href="tel:0119102001"
                                      className="fixed bg-white bg-opacity-80  shadow-2xl text-gray-800      bottom-24  p-3  text-sm flex justify-center items-center rounded-full left-5 z-30"> تلفن
                پشتیبانی : 0119102001</a>}
            <button onClick={handleToggleAction}
                    className="fixed bg-white bg-opacity-80  shadow-2xl text-red-400    bottom-24 p-3   flex justify-center items-center rounded-full  right-5 z-30">{showSupportActions ?
                <MdClose className="text-2xl"/> : <BiSupport className="text-2xl"/>}</button>
        </div>}
        {processInfo && processInfo.current_step.name === "InitConfirm" && !otpActive && <InitConfirm
            processInfo={processInfo}
            accessToken={token}
            handleGetProcess={handleGetProcess}
            handleConfirm={handleInitConfirm}
        />}
        {processInfo && processInfo.current_step.name === "InitConfirm" && otpActive && otpTimer &&
            <OTP key={otpTimer} length={otpConfig.length}
                 title={otpConfig.title}
                 timerCount={otpTimer}
                 handleRequestOTP={handleRequestOTP}
                 confirmLoading={otpConfirmLoading}
                 retryLoading={otpRequestLoading}
                 handleConfirm={handleConfirmOTP}
                 error={otpError}
                 description={otpDescription}
            />}
        {processInfo && (processInfo?.current_step?.name === "CreatePayment" || processInfo?.current_step?.name === "InquiryPayment") &&
            <Payment
                payment={processInfo.payment}
                handlePayment={handleCreatePayment}/>}

        {((processInfo && processInfo?.current_step?.name === "final") || isReported) && <div
            className="mt-3  w-11/12 md:w-6/12 lg:w-4/12  mx-auto  p-7 flex justify-center items-center flex-col  rounded-lg  shadow-sm   bg-white ">
            <TbShieldCheckFilled className="text-green-500 text-6xl "/>
            <p className=" font-bold mt-5 mb-1  text-center">{warning ? "" : "اصالت ملک با موفقیت انجام شد."}</p>
            <p className=" text-sm mt-1 mb-3  text-center">{warning ? warning : "مشخصات ملک روی آگهی درج گردید."}</p>
            <div className="mt-3 grid w-full  gap-3">
                <div className="mt-3 grid w-full grid-cols-1 gap-3">
                    {
                        <Button className="text-sm" theme="green" rounded="rounded-lg" onClick={() => {
                            handleRedirect('success', processInfo?.payment?.info?.init_amount);
                        }}>بازگشت
                        </Button>
                    }

                </div>
            </div>
        </div>}
    </div>
}
export default EstateOriginality;